import { render } from "./DeletedChats.vue?vue&type=template&id=4fc5ff68"
import script from "./DeletedChats.vue?vue&type=script&lang=js"
export * from "./DeletedChats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__